<template>
    <form-wrapper class="patient-add-form" @submit="handleFormSubmission(data)">
        <form-row>
            <form-cell width="half">
                <label class="form-field__label">
                    {{ $t('forms.addpatient.fields.insurance_plans.placeholder_patient') }}
                </label>
                <select-input
                    :placeholder="$t('forms.addpatient.fields.insurance_plans.start_typing')"
                    :options="insurancePlans"
                    :groupOptions="true"
                    :expandOptionsRight="true"
                    :isSearchable="true"
                    :value="insuranceId"
                    icon="insurance"
                    @change="changeInsurance($event)"
                ></select-input>
            </form-cell>
            <form-cell width="half">
                <text-field
                    :label="$t('forms.addpatient.fields.insurance.label')"
                    :placeholder="$t('forms.addpatient.fields.insurance.placeholder')"
                    :isRequired="false"
                    :formData="data"
                    valuePath="insuranceGroupNumber"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <text-field
                    :label="$t('forms.addpatient.fields.insurance_id.label')"
                    :placeholder="$t('forms.addpatient.fields.insurance_id.placeholder')"
                    :isRequired="false"
                    :formData="data"
                    valuePath="insuranceNumber"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell width="half">
                <text-field
                    :label="$t('forms.addpatient.fields.name.label')"
                    :placeholder="$t('forms.addpatient.fields.name.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="firstName"
                    @change="change($event)"
                ></text-field>
            </form-cell>
            <form-cell width="half">
                <text-field
                    :label="$t('forms.addpatient.fields.lastname.label')"
                    :placeholder="$t('forms.addpatient.fields.lastname.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="lastName"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>

        <form-row>
            <form-cell width="half">
                <birth-date-field
                    :label="$t('forms.addpatient.fields.date.label')"
                    :placeholder="$t('forms.addpatient.fields.date.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="dob"
                    @change="change($event)"
                ></birth-date-field>
            </form-cell>
            <form-cell width="half">
                <text-field
                    :label="$t('forms.addpatient.fields.ssn.label')"
                    :placeholder="$t('forms.addpatient.fields.ssn.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="last4ssn"
                    type="number"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>
        <form-row>
            <form-cell width="half">
                <phone-field
                    :label="$t('forms.addpatient.fields.phone.label')"
                    :placeholder="$t('forms.addpatient.fields.phone.placeholder')"
                    :isRequired="true"
                    :formData="data"
                    valuePath="phoneNumber"
                    type="number"
                    @change="change($event)"
                ></phone-field>
            </form-cell>
            <form-cell width="half">
                <text-field
                    class="patient-detail-form-text"
                    :label="$t('forms.addpatient.fields.email.label')"
                    :placeholder="$t('forms.addpatient.fields.email.placeholder')"
                    :isRequired="false"
                    :formData="data"
                    valuePath="email"
                    @change="change($event)"
                ></text-field>
            </form-cell>
        </form-row>
        <div class="accordian">
            <common-accordion :title="$t('forms.addpatient.fields.demographics.label')">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.profile.gender.label')"
                            :placeholder="$t('forms.patient_profile.fields.profile.gender.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="gender"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.profile.marital_status.label')"
                            :placeholder="$t('forms.patient_profile.fields.profile.marital_status.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="maritalStatus"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.profile.language.label')"
                            :placeholder="$t('forms.patient_profile.fields.profile.language.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="preferredLanguage"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.profile.contact_info.label')"
                            :placeholder="$t('forms.patient_profile.fields.profile.contact_info.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="preferredContactMethod"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </common-accordion>
        </div>
        <div class="accordian">
            <common-accordion :title="$t('forms.addpatient.fields.address.label')">
                <form-row>
                    <form-cell width="half">
                        <suggest-field
                            :label="$t('forms.addpatient.fields.address.label')"
                            :placeholder="$t('forms.patient.patient_information.fields.location_address.placeholder')"
                            :suggestionsCall="addressSuggestionCall"
                            :isRequired="false"
                            :isSuggested="false"
                            :formData="data"
                            valuePath="address"
                            @change="change($event)"
                            @select="changeLocationAddress($event)"
                        ></suggest-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.addpatient.fields.city.label')"
                            :placeholder="$t('forms.addpatient.fields.city.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="city"
                            valuePath="city"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="quarter">
                        <select-field
                            :label="$t('forms.addpatient.fields.state.label')"
                            :placeholder="$t('forms.addpatient.fields.state.placeholder')"
                            :options="states"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="state"
                            valuePath="state"
                            @change="change($event)"
                        ></select-field>
                    </form-cell>
                    <form-cell width="quarter">
                        <text-field
                            :label="$t('forms.addpatient.fields.zip.label')"
                            :placeholder="$t('forms.addpatient.fields.zip.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="zip"
                            valuePath="zip"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="quarter">
                        <text-field
                            :label="$t('forms.addpatient.fields.floor_number.label')"
                            :placeholder="$t('forms.addpatient.fields.floor_number.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="floorNumber"
                            valuePath="floorNumber"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="quarter">
                        <text-field
                            :label="$t('forms.addpatient.fields.apartment_number.label')"
                            :placeholder="$t('forms.addpatient.fields.apartment_number.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="apartmentNumber"
                            valuePath="apartmentNumber"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="quarter">
                        <text-field
                            :label="$t('forms.addpatient.fields.building_number.label')"
                            :placeholder="$t('forms.addpatient.fields.building_number.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="buildingNumber"
                            valuePath="buildingNumber"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </common-accordion>
        </div>
        <div class="accordian">
            <common-accordion :title="$t('forms.addpatient.fields.guarantor.label')">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.addpatient.fields.guarantor.name.label')"
                            :placeholder="$t('forms.addpatient.fields.guarantor.name.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="guarantorFirstName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.addpatient.fields.guarantor.lastname.label')"
                            :placeholder="$t('forms.addpatient.fields.guarantor.lastname.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="guarantorLastName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <phone-field
                            :label="$t('forms.addpatient.fields.guarantor.phone.label')"
                            :placeholder="$t('forms.addpatient.fields.guarantor.phone.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="guarantor.phone"
                            type="number"
                            @change="change($event)"
                        ></phone-field>
                    </form-cell>
                </form-row>
            </common-accordion>
        </div>
        <div class="accordian">
            <common-accordion :title="$t('forms.addpatient.fields.emergency.label')">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.emergency.first_name.lable')"
                            :placeholder="$t('forms.patient_profile.fields.emergency.first_name.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="emergencyContact.firstName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.emergency.last_name.lable')"
                            :placeholder="$t('forms.patient_profile.fields.emergency.last_name.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="emergencyContact.lastName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <phone-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.emergency.phone.lable')"
                            :placeholder="$t('forms.patient_profile.fields.emergency.phone.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="emergencyContact.phone"
                            type="number"
                            @change="change($event)"
                        ></phone-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                            :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="emergencyContact.email"
                            type="email"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.emergency.relationship.lable')"
                            :placeholder="$t('forms.patient_profile.fields.emergency.relationship.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="emergencyContact.relationship"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </common-accordion>
        </div>
        <div class="accordian">
            <common-accordion :title="$t('forms.addpatient.fields.pharmacy.label')">
                <form-row>
                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.pharmacy.name.lable')"
                            :placeholder="$t('forms.patient_profile.fields.pharmacy.name.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="pharmacyName"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <suggest-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.pharmacy.address.label')"
                            :placeholder="$t('forms.patient_profile.fields.pharmacy.address.placeholder')"
                            :suggestionsCall="addressSuggestionCall"
                            :isRequired="false"
                            :isSuggested="false"
                            :formData="data"
                            valuePath="pharmacyAddress"
                            @change="change($event)"
                            @select="changePharmacyAddress($event)"
                        ></suggest-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.addpatient.fields.city.label')"
                            :placeholder="$t('forms.addpatient.fields.city.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="city"
                            valuePath="pharmacyCity"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                    <form-cell width="half">
                        <select-field
                            :label="$t('forms.addpatient.fields.state.label')"
                            :placeholder="$t('forms.addpatient.fields.state.placeholder')"
                            :options="states"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="state"
                            valuePath="pharmacyState"
                            @change="change($event)"
                        ></select-field>
                    </form-cell>
                    <form-cell width="half">
                        <text-field
                            :label="$t('forms.addpatient.fields.zip.label')"
                            :placeholder="$t('forms.addpatient.fields.zip.placeholder')"
                            :isDisabled="isDisabled"
                            :isSuggested="false"
                            :formData="data"
                            errorPath="zip"
                            valuePath="pharmacyZip"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell width="half">
                        <phone-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.pharmacy.phone.lable')"
                            :placeholder="$t('forms.patient_profile.fields.pharmacy.phone.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="pharmacyPhone"
                            type="number"
                            @change="change($event)"
                        ></phone-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.pharmacy.email.label')"
                            :placeholder="$t('forms.patient_profile.fields.pharmacy.email.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="pharmacyEmail"
                            type="email"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            class="patient-detail-form-text"
                            :label="$t('forms.patient_profile.fields.pharmacy.fax.lable')"
                            :placeholder="$t('forms.patient_profile.fields.pharmacy.fax.placeholder')"
                            :isRequired="false"
                            :formData="data"
                            valuePath="fax"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
            </common-accordion>
        </div>
        <div class="patient-add-form__button">
            <common-buttons>
                <common-button
                    :isProcessing="isSending"
                    :label="$t('pages.patient.details.button.primary')"
                    type="primary"
                ></common-button>
            </common-buttons>
        </div>
    </form-wrapper>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'
    import Store from '~/store'
    import StatesAPI from 'api/StatesAPI'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'
    export default {
        mixins: [FormMixin, HandleRequestMixin, FormDisableableMixin],

        data() {
            return {
                insuranceId: null,
                insurancePlans: [],
                address: {},
                states: [],
            }
        },
        computed: {
            addressSuggestionCall() {
                //eslint-disable-next-line no-undef
                const autocompleteService = new google.maps.places.AutocompleteService()
                return (query) => {
                    const request = {
                        input: query,
                        componentRestrictions: { country: 'US' },
                    }
                    return autocompleteService.getPlacePredictions(request).then((results) => {
                        return results?.predictions?.map((item) => {
                            return {
                                label: item.description,
                                value: item.place_id,
                            }
                        })
                    })
                }
            },
        },

        methods: {
            areRequiredFieldsFilled() {
                const requiredFields = [
                    this.data.firstName,
                    this.data.lastName,
                    this.data.dob,
                    this.data.last4ssn,
                    this.data.phoneNumber,
                ]

                return requiredFields.every((field) => !!field && field.toString().trim().length > 0)
            },
            changeInsurance(event) {
                this.insuranceId = event
            },
            changeLocationAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }
                let addressComponents = {}
                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zip = component.long_name
                                        break
                                }
                            })
                        })
                        this.$set(
                            this.data,
                            'address',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'city', addressComponents.city || '')
                        this.$set(this.data, 'state', addressComponents.state || '')
                        this.$set(this.data, 'zip', addressComponents.zip || '')
                        this.isSuggested = true
                    }
                })
            },
            changePharmacyAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }
                let addressComponents = {}
                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zip = component.long_name
                                        break
                                }
                            })
                        })
                        this.$set(
                            this.data,
                            'pharmacyAddress',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'pharmacyCity', addressComponents.city || '')
                        this.$set(this.data, 'pharmacyState', addressComponents.state || '')
                        this.$set(this.data, 'pharmacyZip', addressComponents.zip || '')
                    }
                })
            },

            handleFormSubmission(data) {
                if (!this.areRequiredFieldsFilled()) {
                    return
                }
                this.isSending = true
                const newData = {
                    firstName: data.firstName,
                    lastName: data.lastName,
                    dob: data.dob,
                    last4ssn: data.last4ssn,
                    phoneNumber: data.phoneNumber,
                    email: data.email,
                    guarantor: {
                        phone: data.guarantor?.phone,
                        lastName: data.guarantorLastName,
                        firstName: data.guarantorFirstName,
                    },
                    address: {
                        address: data.address,
                        city: data.city,
                        state: data.state,
                        zip: data.zip,
                        floorNumber: data.floorNumber,
                        apartmentNumber: data.apartmentNumber,
                        buildingNumber: data.buildingNumber,
                    },
                    primaryInsuranceTypeId: this.insuranceId,
                    insuranceNumber: data.insuranceNumber,
                    insuranceGroupNumber: data.insuranceGroupNumber,
                    gender: data?.gender ? data?.gender.toString().trim().toLowerCase() : null,
                    maritalStatus: data.maritalStatus,
                    preferredLanguage: data.preferredLanguage,
                    preferredContactMethod: data.preferredContactMethod,
                    emergencyContact: {
                        firstName: data.emergencyContact?.firstName,
                        lastName: data.emergencyContact?.lastName,
                        phone: data.emergencyContact?.phone,
                        email: data.emergencyContact?.email,
                        relationship: data.emergencyContact?.relationship,
                    },
                    preferredFarmacy: {
                        name: data.pharmacyName,
                        address: data.pharmacyAddress,
                        city: data.pharmacyCity,
                        state: data.pharmacyState,
                        zip: data.pharmacyZip,
                        phone: data.pharmacyPhone,
                        email: data.pharmacyEmail,
                        fax: data.fax,
                    },
                }

                this.handleRequest(PatientAPI.add(this.$auth.getActiveMember().id, newData))
                    .then(() => {
                        this.$router.push('/patients/list/patients')
                    })
                    .finally(() => {
                        this.isSending = false
                    })
            },
        },

        async mounted() {
            this.insurancePlans = Store.getters['auth/getInsurancePlans']
            this.states = await StatesAPI.getList()
        },
    }
</script>

<style>
    .patient-add-form__button {
        margin-top: 50px;
    }
    .accordian + .accordian {
        margin-top: 10px;
    }

    .accordian {
        margin-top: 40px;
    }
</style>
